module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_9006.1a406fb9.png";